module.exports = __webpack_public_path__ + "img/linux.4efb6206.png";